<!-- start header  -->
<header>
  <app-head (newItemEvent)="addItem($event)" [titleModule]="'checkOut'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">
  <!-- start sidebar  -->
  <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'checkOut'"></app-sidebar>
  <!-- end sidebar  -->
  <!-- start content page  -->
  <main class="p-4 col-lg-10">


    <!-- <div class="tabview-header-container mb-4"> -->
    <div class="tabview-header-container">

      <p-breadcrumb class="max-w-full" [model]="items">
        <ng-template pTemplate="item" let-item>
          <a [routerLink]="item.routerLink" class="p-menuitem-link"
            routerLinkActive="text-primary font-semibold bread-active">
            <span *ngIf="item.icon" [ngClass]="item.icon" class="mr-2"></span>
            <span>{{ item.label }}</span>
          </a>
        </ng-template>
      </p-breadcrumb>

    </div>

    <!-- Checkout -->
    <div class="card p-4 bg-white">

      <div class="row card-line">

        <div class="col-lg-3 col-md-6 ">
          <div class="row ">
            <div class=" col-3">
              <img class="rounded-pill img-fluid p-1" [src]=" staff?.staff_Profile_Pic && staff?.staff_Profile_Pic !== 'none' && staff?.staff_Profile_Pic !== ''
                             ? staff?.staff_Profile_Pic
                             : '/images/staff/Frame.svg'" alt="user">

            </div>

            <div class="col-9">
              <p style="color: #0A0C0F; font-weight: 500; font-size: 16px;">llllll{{staff?.staff_Name}} </p>
              <p style="color: #727272;">llllll{{staff?.staff_cost}}</p>
              <div class="row g-2 mb-2">
                <!-- Phone -->
                <a [href]="'tel:' + staff?.staf_Availbaility" class="col-3">
                  <img class="rounded" style="background-color: #F6F9FE;" src="/assets/images/checkout/call.svg"
                    alt="phoneicon">
                </a>

                <!-- WhatsApp -->
                <a [href]="'https://wa.me/' + staff?.personal_Info_View?.staff_WA_Num" target="_blank" class="col-3">
                  <img class="rounded " style="background-color: #F6F9FE;" src="/assets/images/checkout/whatsapp.svg"
                    alt="SocialIcons">
                </a>

                <!-- Email -->
                <a [href]="'mailto:' + staff?.staff_Email" class="col-3">
                  <img class="rounded" style="background-color: #F6F9FE;" src="/assets/images/checkout/email.svg"
                    alt="EmailIcon">
                </a>

                <!-- Chat -->
                <a [href]="'sms:' + staff?.data" class="col-3">
                  <img class="rounded" style="background-color: #F6F9FE;" src="/assets/images/checkout/chat.svg"
                    alt="Chat-CircleIcon">
                </a>
              </div>
            </div>
          </div>

        </div>

        <div class="col-lg-9 col-md-12 add-top-space">
          <div class="row">
            <div class="add-top-space col-md-3 horizontal-line1 ">
              <div class="title">
                <img class="icon" src="/assets/images/checkout/book.svg" alt="bookIcon">
                <span>Booking ID</span>
              </div>

              <div class="ms-4">
                <p>10:00 AM</p>

              </div>
            </div>

            <div class="add-top-space col-md-3 horizontal-line1 ">
              <div class="title">
                <img class="icon" src="/assets/images/checkout/StartDate.svg" alt="Start Date">
                <span>Start Date</span>

              </div>
              <div class="ms-4">
                <p>10:00 AM</p>

              </div>
            </div>

            <div class="add-top-space col-md-3 horizontal-line1 ">
              <div class="title">
                <img class="icon" src="/assets/images/checkout/StartDate.svg" alt="End Date">
                <span>End Date</span>

              </div>
              <div class="ms-4">
                <p>10:00 AM</p>

              </div>
            </div>

            <div class="add-top-space col-md-3 horizontal-line1 ">
              <div class="title">
                <img class="icon" src="/assets/images/checkout/StartDate.svg" alt="Start Date">
                <span>Checkout Date</span>

              </div>
              <div class="ms-4">
                <p>10:00 AM</p>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between p-3 mt-4 rounded " style="background-color: #F6F9FE;">
        <span style="color: #0A0C0F; font-weight: 400; font-size: 16px;">Security Deposit Paid </span>
        <span style="color: #1151B4; font-weight: 500; font-size: 20px;">€ 1500</span>
      </div>

    </div>


    <!-- Apartment Condition -->
    <div class="card mt-3 p-3 bg-white">

      <div class="d-flex justify-content-between p-3 rounded ">
        <span style="color: #0A0C0F; font-weight: 500; font-size: 18px;">Apartment Condition</span>

        <div class="">
          <p-button (onClick)="showDialog()" icon="pi pi-plus" label="Add new Expense" class="btn-expense" />

          <p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '55rem'}">
            <ng-template pTemplate="header">
              <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="font-bold white-space-nowrap">
                  Add new expense
                </span>
              </div>
            </ng-template>
            <div class="flex justify-content-around">
              <div class=" align-items-center mb-3">
                <label style="color: #605D62; font-size: 14px;" for="expense" class="d-block">
                  Expense type
                </label>
                <input pInputText id="expense" autocomplete="off" class="w-25rem" />
              </div>
              <div class="align-items-center mb-5">
                <label style="color: #605D62; font-size: 14px;" for="cost" class="d-block">
                  Cost of expense
                </label>
                <input pInputText id="cost" class=" w-25rem" autocomplete="off" />
              </div>
            </div>

            <!-- TextArea -->
            <div>
              <label for="description" class="d-block">Description of the expenses</label>
              <textarea class="form-control" rows="4" name="description" id="description"></textarea>
            </div>

            <!-- attachments -->
            <div class="row mt-4 mx-1">
              <div class="form-item">
                <span style="color: #605D62;"> attachments</span>
              </div>
              <div class="photo-card rounded px-3 pt-3 mt-3" style="border: #EEF0F1 2px solid;">
                <div class="mt-1 mb-3 row g-2  align-items-center">
                  <div class="col-md" *ngFor="let file of  files; let i=index">
                    <!-- <img [src]="file" [alt]="file.name" class="rounded w-100 fix-img" alt="kitchen">
                  <button (click)="onRemoveFile(file,  i)">Remove</button> -->
                    <div class="image-wrapper position-relative fix-img">
                      <img [src]="file" alt="uploaded image" class="rounded w-100 h-100" />

                      <i class="pi pi-times close-icon" (click)="onRemoveFile(file, i)" title="Remove"></i>
                    </div>
                  </div>



                  <div class="col-md text-center">

                    <p-toast />

                    <div class="col-auto text-center d-flex align-items-center justify-content-center">
                      <p-fileUpload name="myfile" accept="image/*" [multiple]="true" [customUpload]="true"
                        (onSelect)="onSelectedFiles($event)">

                        <ng-template pTemplate="header" let-chooseCallback="chooseCallback">
                          <label style="cursor: pointer; display: flex; flex-direction: column; align-items: center;"
                            (click)="chooseCallback()">
                            <img src="/assets/images/checkout/upload.svg" alt="uploadicon" width="50px" />
                            <p style="color: #605D62;">or drag and drop</p>
                          </label>
                        </ng-template>
                      </p-fileUpload>
                    </div>

                  </div>

                </div>
              </div>
            </div>


            <div style=" width: 99%; margin: auto; border-top: 1px solid #EEF0F1;" class="mt-4"></div>

            <!-- Buttons -->
            <ng-template pTemplate="footer">
              <div class="footer-buttons d-flex justify-content-between w-100">
                <p-button class="footer-btn-cancel" label="Cancel" [text]="true" severity="secondary"
                  (onClick)="visible = false" />

                <p-button class="footer-btn-Confirm" label="Confirm" severity="success" (onClick)="confirm()" />

              </div>
            </ng-template>

          </p-dialog>

        </div>

      </div>

      <!-- dialog 2 -->

      <p-dialog [(visible)]="confirmVisible" [modal]="true" [closable]="false" [style]="{ width: '40rem' }">
        <ng-template pTemplate="content">
          <div class="text-center py-4">
            <i class="pi pi-check-circle" style="font-size: 2rem; color: green;"></i>
            <h3 style="color: #101828;">sent successfully!</h3>
            <p class="mt-3" style="color: #475467;">
              <span style="font-weight: 700;">check out sheet</span>
              has been sent successfully
            </p>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
          <div class="text-center w-100">
            <p-button label="OK" (onClick)="confirmVisible = false" autofocus />
          </div>
        </ng-template>
      </p-dialog>

      <!-- Photos -->
      <div>

        <div>
          <div class=" flex justify-center mt-3">
            <p-accordion>
              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div>
                    <img class="me-2" src="/assets/images/KitchenIcon.svg" alt="KitchenIcon">
                    <span style="color: #0A0C0F; font-size: 16px; font-weight: 500;">Kitchen</span>
                  </div>
                </ng-template>

                <div class="line mb-3" style=" width: 99%; height: 1px; background: #EEF0F1;"></div>
                <div class="row">
                  <!-- Handover Status -->
                  <div class="col-lg-6 px-3 pt-3 horizontal-line3">
                    <div>
                      <span class="px-1" style="color: #363636; font-size: 14px; font-weight: 400;">
                        Handover Status
                      </span>
                    </div>
                    <div class="mt-1 mb-3 row g-2">

                      <div class="col-md-6">
                        <img class="rounded w-100" [src]="" alt="Before Image">
                      </div>
                    </div>
                  </div>

                  <!-- Check-out Status -->
                  <div class="col-lg-6 px-3 pt-3">
                    <div>
                      <span class="px-1" style="color: #363636; font-size: 14px; font-weight: 400;">
                        Check-out Status
                      </span>
                    </div>
                    <div class="mt-1 mb-3 row g-2">
                      <div class="col-md-6">
                        <img class="rounded w-100" [src]="" alt="After Image">
                      </div>
                    </div>
                  </div>

                </div>

              </p-accordionTab>

              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div>
                    <img class="me-2" src="/assets/images/bathIcon.svg" alt="Bathroom">
                    <span style="color: #0A0C0F; font-size: 16px; font-weight: 500;">Bathroom</span>
                  </div>
                </ng-template>
                <div class="line mb-3" style=" width: 99%; height: 1px; background: #EEF0F1;"></div>
                <div class="row">
                  <!-- Handover Status -->
                  <div class="col-lg-6 px-3 pt-3 horizontal-line3">
                    <div>
                      <span class="px-1" style="color: #363636; font-size: 14px; font-weight: 400;">
                        Handover Status
                      </span>
                    </div>
                    <div class="mt-1 mb-3 row g-2">
                      <div class="col-md-6">
                        <img class="rounded w-100" [src]="" alt="Before Image">
                      </div>
                    </div>
                  </div>

                  <!-- Check-out Status -->
                  <div class="col-lg-6 px-3 pt-3">
                    <div>
                      <span class="px-1" style="color: #363636; font-size: 14px; font-weight: 400;">
                        Check-out Status
                      </span>
                    </div>
                    <div class="mt-1 mb-3 row g-2">
                      <div class="col-md-6">
                        <img class="rounded w-100" [src]="" alt="After Image">
                      </div>
                    </div>
                  </div>

                </div>

              </p-accordionTab>

              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div>
                    <img class="me-2" src="/assets/images/bedroomIcon.svg" alt="Bedroom">
                    <span style="color: #0A0C0F; font-size: 16px; font-weight: 500;">Bedroom</span>
                  </div>
                </ng-template>
                <div class="line mb-3" style=" width: 99%; height: 1px; background: #EEF0F1;"></div>
                <div class="row">
                  <!-- Handover Status -->
                  <div class="col-lg-6 px-3 pt-3 horizontal-line3">
                    <div>
                      <span class="px-1" style="color: #363636; font-size: 14px; font-weight: 400;">
                        Handover Status
                      </span>
                    </div>
                    <div class="mt-1 mb-3 row g-2">
                      <div class="col-md-6">
                        <img class="rounded w-100" [src]="" alt="Before Image">
                      </div>
                    </div>
                  </div>

                  <!-- Check-out Status -->
                  <div class="col-lg-6 px-3 pt-3">
                    <div>
                      <span class="px-1" style="color: #363636; font-size: 14px; font-weight: 400;">
                        Check-out Status
                      </span>
                    </div>
                    <div class="mt-1 mb-3 row g-2">
                      <div class="col-md-6">
                        <img class="rounded w-100" [src]="" alt="After Image">
                      </div>
                    </div>
                  </div>

                </div>

              </p-accordionTab>
            </p-accordion>
          </div>
        </div>

      </div>

    </div>

    <!-- List of Repairs -->
    <div class="card p-4 mt-3 bg-white">

      <div class="px-2 my-3">
        <span style="color: #4A4A4A; font-size: 16px;">List of Repairs that you will have to Pay for :</span>

        <div class="row gap-3">

          <div class="col-lg border rounded mt-3 p-3" style="border: #EEF0F1 1px solid;">
            <h6>Electricity Failure</h6>

            <div class="row">
              <div class="col-md-6 px-4">
                <div class="d-flex">
                  <div class="mt-3 me-2">
                    <img class="icon" src="/assets/images/checkout/book.svg" alt="bookIcon">
                  </div>

                  <div class="mt-2">
                    <span class="title d-block">Problem ID</span>
                    <span>llllllllll</span>
                  </div>
                </div>

              </div>
              <div class="col-md-6 px-4 horizontal-line4">
                <div class="d-flex">
                  <div class="mt-3 me-2">
                    <img class="icon" src="/assets/images/checkout/calendar.svg" alt="DateIcon">
                  </div>

                  <div class="mt-2">
                    <span class="title d-block">Problem Date</span>
                    <span>llllllllll</span>
                  </div>
                </div>
              </div>

            </div>

            <p style="color: #727272; font-size: 16px;" class="my-3">A power socket was damaged and not working.
              Technician replaced
              the socket and
              ensured safe wiring.</p>

            <p style="font-size: 18px;">Cost of Problem :
              <span style="color: #1151B4; font-size: 18px; font-weight: 500;">€ 300</span>
            </p>

          </div>

          <div class="col-lg border rounded mt-3 p-3" style="border: #EEF0F1 1px solid;">
            <h6>Electricity Failure</h6>

            <div class="row">
              <div class="col-md-6 px-4">
                <div class="d-flex">
                  <div class="mt-3 me-2">
                    <img class="icon" src="/assets/images/checkout/book.svg" alt="bookIcon">
                  </div>

                  <div class="mt-2">
                    <span class="title d-block">Problem ID</span>
                    <span>llllllllll</span>
                  </div>
                </div>

              </div>
              <div class="col-md-6 px-4 horizontal-line4">
                <div class="d-flex">
                  <div class="mt-3 me-2">
                    <img class="icon" src="/assets/images/checkout/calendar.svg" alt="DateIcon">
                  </div>

                  <div class="mt-2">
                    <span class="title d-block">Problem Date</span>
                    <span>llllllllll</span>
                  </div>
                </div>
              </div>

            </div>

            <p style="color: #727272; font-size: 16px;" class="my-3">A power socket was damaged and not working.
              Technician replaced
              the socket and
              ensured safe wiring.</p>

            <p style="font-size: 18px;">Cost of Problem :
              <span style="color: #1151B4; font-size: 18px; font-weight: 500;">€ 300</span>
            </p>

          </div>

        </div>


      </div>

    </div>

    <!-- Apartment Expenses -->
    <div class="card p-4 mt-3 bg-white">

      <div class="px-2 my-3">
        <span style="color: #4A4A4A; font-size: 16px;">Apartment Expenses during the Rental Period :</span>

        <div class="row gap-3">

          <div class=" border rounded mt-3 p-3" style="border: #EEF0F1 1px solid;">

            <div class="d-flex justify-content-between">
              <h6 class="title">Cleaning</h6>
              <div class="">

                <div class="card flex justify-content-center">

                  <p-button (onClick)="showEditDialog()" label=":" class="" />

                  <p-dialog header="Header" [(visible)]="visibleEdit" [modal]="true" [style]="{ width: '55rem'}">
                    <ng-template pTemplate="header">
                      <div class="inline-flex align-items-center justify-content-center gap-2">
                        <span class="font-bold white-space-nowrap">
                          Edit new expense
                        </span>
                      </div>
                    </ng-template>
                    <div class="flex justify-content-around">
                      <div class=" align-items-center mb-3">
                        <label style="color: #605D62; font-size: 14px;" for="expense" class="d-block">
                          Expense type
                        </label>
                        <input pInputText id="expense" autocomplete="off" class="w-25rem" />
                      </div>
                      <div class="align-items-center mb-5">
                        <label style="color: #605D62; font-size: 14px;" for="cost" class="d-block">
                          Cost of expense
                        </label>
                        <input pInputText id="cost" class=" w-25rem" autocomplete="off" />
                      </div>
                    </div>

                    <!-- TextArea -->
                    <div>
                      <label for="description" class="d-block">Description of the expenses</label>
                      <textarea class="form-control" rows="4" name="description" id="description"></textarea>
                    </div>

                    <!-- attachments -->
                    <div class="row mt-4 mx-1">
                      <div class="form-item">
                        <span style="color: #605D62;"> attachments</span>
                      </div>
                      <div class="photo-card rounded px-3 pt-3 mt-3" style="border: #EEF0F1 2px solid;">
                        <div class="mt-1 mb-3 row g-2  align-items-center">
                          <div class="col-md" *ngFor="let file of  files; let i=index">
                            <!-- <img [src]="file" [alt]="file.name" class="rounded w-100 fix-img" alt="kitchen">
                  <button (click)="onRemoveFile(file,  i)">Remove</button> -->
                            <div class="image-wrapper position-relative fix-img">
                              <img [src]="file" alt="uploaded image" class="rounded w-100 h-100" />

                              <i class="pi pi-times close-icon" (click)="onRemoveFile(file, i)" title="Remove"></i>
                            </div>
                          </div>


                          <div class="col-md text-center">

                            <p-toast />

                            <div class="col-auto text-center d-flex align-items-center justify-content-center">
                              <p-fileupload name="myfile" accept="image/*" [multiple]="true" [customUpload]="true"
                                (onSelect)="onSelectedFiles($event)">

                                <ng-template pTemplate="header" let-chooseCallback="chooseCallback">
                                  <label
                                    style="cursor: pointer; display: flex; flex-direction: column; align-items: center;"
                                    (click)="chooseCallback()">
                                    <img src="/assets/images/checkout/upload.svg" alt="uploadicon" width="50px" />
                                    <p style="color: #605D62;">or drag and drop</p>
                                  </label>
                                </ng-template>
                              </p-fileupload>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>


                    <div style=" width: 99%; margin: auto; border-top: 1px solid #EEF0F1;" class="mt-4"></div>

                    <!-- Buttons -->
                    <ng-template pTemplate="footer">
                      <div class="footer-buttons d-flex justify-content-between w-100">
                        <p-button class="footer-btn-cancel" label="Cancel" [text]="true" severity="secondary"
                          (onClick)="visibleEdit = false" />
                        <p-button class="footer-btn-Confirm" label="Confirm" severity="success"
                          (onClick)="Editconfirm()" />
                      </div>
                    </ng-template>

                  </p-dialog>

                </div>


                <!-- dialog 2 -->

                <p-dialog [(visible)]="confirmVisible" [modal]="true" [closable]="false" [style]="{ width: '40rem' }">
                  <ng-template pTemplate="content">
                    <div class="text-center py-4">
                      <i class="pi pi-check-circle" style="font-size: 2rem; color: green;"></i>
                      <h3 style="color: #101828;">sent successfully!</h3>
                      <p class="mt-3" style="color: #475467;">
                        <span style="font-weight: 700;">check out sheet</span>
                        has been sent successfully
                      </p>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <div class="text-center w-100">
                      <p-button label="OK" (onClick)="confirmVisible = false" autofocus />
                    </div>
                  </ng-template>
                </p-dialog>


              </div>
            </div>

            <p style="color: #727272; font-size: 16px;" class="">A power socket was damaged and not working.
              Technician replaced the socket and ensured safe wiring.</p>

            <p style="font-size: 18px;">Cost of Problem :
              <span style="color: #1151B4; font-size: 18px; font-weight: 500;">€ 300</span>
            </p>

          </div>

        </div>

      </div>

    </div>

    <!-- Invoice Summary -->
    <div class="card p-4 mt-3 bg-white">

      <h5>Invoice Summary</h5>

      <div class="rounded mt-3" style="background-color: #F6F9FE;">

        <div class="d-flex justify-content-between p-3 mt-2 " style="color: #0A0C0F; ">
          <span style="font-size: 16px;">Security Deposit</span>
          <span style="font-size: 18px;">€ 1500</span>
        </div>

        <div class="d-flex justify-content-between p-3 mt-2 ">
          <span style="color: #0A0C0F; font-size: 16px;">Deductions
            <span style="color: #727272; font-size: 14px;"> Problems & Expenses</span>
          </span>
          <span style="color: #0A0C0F; font-size: 18px;">€ 1500</span>
        </div>

        <div style=" width: 99%; margin: auto; border-top: 3px dashed #EEF0F1;"></div>

        <div class="d-flex justify-content-between p-3 mt-2 " style="color: #1151B4; font-weight: 500;">
          <span style="font-size: 16px;">Remaining</span>
          <span style="font-size: 18px;">€ 1500</span>
        </div>

      </div>

      <!-- Buttons -->
      <div class="d-flex gap-4 justify-content-end mt-4">
        <button class="btn-cancel rounded">Cancel</button>
        <button class="btn-send rounded">Send Checkout</button>
      </div>

    </div>

  </main>
</div>
